import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ModeProvider } from "./context/ModeContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./utils/i18n";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LocaleProvider } from "./context/LocaleContext";
import WhiteCloseButton from "./components/WhiteCloseButton";
import WebViewErrorBoundary from "./components/WebViewErrorBoundary";
import { initWebViewPolyfills } from "./utils/webviewPolyfills";

import * as Sentry from "@sentry/react";
import { config } from "./utils/config";

// Initialize WebView polyfills and error handlers early
initWebViewPolyfills();

Sentry.init({
  dsn: config.sentryDsn,
  sendDefaultPii: true,
  beforeSend(event) {
    // Filter out WebView bridge errors to reduce noise
    if (event.exception?.values?.[0]?.value?.includes('Java object is gone')) {
      console.warn('Filtered WebView bridge error from Sentry:', event.exception.values[0].value);
      return null; // Don't send to Sentry
    }
    return event;
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

createRoot(rootElement).render(
  // <StrictMode>
  <WebViewErrorBoundary>
    <I18nextProvider i18n={i18n}>
      <LocaleProvider>
        <ModeProvider>
          <App />
          <ToastContainer closeButton={WhiteCloseButton} />
        </ModeProvider>
      </LocaleProvider>
    </I18nextProvider>
  </WebViewErrorBoundary>
  // </StrictMode>
);